"use client";

import { useState } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import TrustStrip from "@/components/TrustStrip";
import ProblemSection from "@/components/ProblemSection";
import ProcessSection from "@/components/ProcessSection";
import PlatformSection from "@/components/PlatformSection";
import ResultsSection from "@/components/ResultsSection";
import IndustrySection from "@/components/IndustrySection";
import FaqSection from "@/components/FaqSection";
import CtaBanner from "@/components/CtaBanner";
import Footer from "@/components/Footer";
import DemoModal from "@/components/DemoModal";

export default function Home() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const handleOpenDemo = () => setIsDemoModalOpen(true);
  const handleCloseDemo = () => setIsDemoModalOpen(false);

  return (
    <main className="min-h-screen flex flex-col bg-white">
      {/* 1. Navbar */}
      <Navbar onOpenDemo={handleOpenDemo} />

      {/* 2. Hero Section */}
      <HeroSection onOpenDemo={handleOpenDemo} />

      {/* 3. Badges & Client Trust Strip */}
      <TrustStrip />

      {/* 4. Problem Section */}
      <ProblemSection />

      {/* 5. Process Flow Section (Monitor, Nurture, Closure) */}
      <ProcessSection />

      {/* 6. Platform Capabilities & Integration Diagram */}
      <PlatformSection />

      {/* 7. Results EchoLeads reports */}
      <ResultsSection />

      {/* 8. Industry Use Cases with interactive tabs */}
      <IndustrySection />

      {/* 9. FAQ Accordions */}
      <FaqSection />

      {/* 10. Conversion CTA Banner */}
      <CtaBanner onOpenDemo={handleOpenDemo} />

      {/* 11. Footer */}
      <Footer />

      {/* 12. Interactive Demo Booking Modal */}
      <DemoModal isOpen={isDemoModalOpen} onClose={handleCloseDemo} />
    </main>
  );
}
